import script from "./New.vue?vue&type=script&setup=true&lang=js"
export * from "./New.vue?vue&type=script&setup=true&lang=js"

import "./New.vue?vue&type=style&index=0&id=ca1fb560&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca1fb560"]])

export default __exports__